var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'determineCost',
    computed: __assign({}, mapState('violationManage', {
        preCalculate: 'preCalculate',
    }), mapState('balance', {
        balanceData: 'balanceData',
    }), mapState('common', {
        commonLoading: 'commonLoading',
    })),
    props: {
        violationParams: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data: function () {
        return {
            isHasBuy: false,
            usernameZh: '',
        };
    },
    created: function () {
        this.getUserName();
        this.$store.dispatch('common/GET_LOADING');
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        costNumber: function () {
            var _this = this;
            var _a = this, balanceData = _a.balanceData, violationParams = _a.violationParams, isHasBuy = _a.isHasBuy;
            var draw = balanceData.draw;
            var source = violationParams.source;
            var _b = this.preCalculate, afterQueryRemainHasTimes = _b.afterQueryRemainHasTimes, beforeQueryRemainHasTimes = _b.beforeQueryRemainHasTimes, estimateCost = _b.estimateCost, estimateTimes = _b.estimateTimes;
            var isHastimes = beforeQueryRemainHasTimes >= estimateTimes;
            var isHasbalance = draw >= estimateCost;
            var config = {
                text: "\u672C\u6B21\u67E5\u8BE2\u8FDD\u7AE0\u9884\u8BA1" + estimateTimes + "\u8F66\u6B21\u3002\u672C\u6708\u5F53\u524D\u5269\u4F59\u8FDD\u7AE0\u67E5\u8BE2\u6B21\u6570" + beforeQueryRemainHasTimes + "\u8F66\u6B21\uFF0C",
                comfirmBtnText: '确 定',
                title: '',
                operation: 0,
                type: '',
            };
            switch (source) {
                case 'TENANT':
                    config.title = '一键查询';
                    break;
                case 'UPLOAD':
                    config.title = '批量查询';
                    break;
                case 'SINGLE':
                    config.title = '单个查询';
                    break;
                default:
                    config.title = '违章查询';
            }
            isHasBuy &&
                ((config.title = '购买完成，是否继续查询？'), (config.type = 'warning'));
            switch (true) {
                case isHastimes:
                    config.text += "\u672C\u6B21\u67E5\u8BE2\u540E\u5C06\u5269\u4F59" + afterQueryRemainHasTimes + "\u8F66\u6B21\uFF0C\u662F\u5426\u786E\u8BA4\u67E5\u8BE2\uFF1F";
                    break;
                case !isHastimes && isHasbalance:
                    config.text += "\u8FDD\u7AE0\u67E5\u8BE2\u6B21\u6570\u4E0D\u8DB3\uFF0C\u60A8\u9700\u8D2D\u4E70\u67E5\u8BE2\u6B21\u6570\uFF01\u9884\u8BA1\u652F\u4ED8" + this.$utils.toYuan(estimateCost) + "\u5143\uFF0C\u662F\u5426\u4F7F\u7528\u4F59\u989D\u4ED8\u6B3E\u8D2D\u4E70\u6B21\u6570\uFF1F";
                    config.comfirmBtnText = '确认付款';
                    config.operation = 1;
                    break;
                case !isHastimes && !isHasbalance:
                    config.text += "\u672C\u6B21\u67E5\u8BE2\u9884\u8BA1\u6263\u8D39" + this.$utils.toYuan(estimateCost) + "\u5143\uFF0C\u5F53\u524D\u4F59\u989D\u4E0D\u8DB3\uFF0C\u8BF7\u5148\u5145\u503C\u540E\u67E5\u8BE2\uFF01";
                    config.comfirmBtnText = '去充值';
                    config.operation = 2;
                    break;
                default:
                    '';
            }
            this.$confirm("<p style=\"margin-top:20px;line-height:20px;font-size:14px;color:#41485d\">" + config.text + "</p>", config.title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: config.comfirmBtnText,
                cancelButtonText: '取 消',
                type: config.type,
                customClass: config.type === 'warning' ? 'push-confirm-warn' : 'push-confirm',
            })
                .then(function () {
                switch (config.operation) {
                    case 0:
                        _this.$emit('get-violation-query');
                        break;
                    case 1:
                        _this.purchaseTimes();
                        break;
                    case 2:
                        _this.$router.push({ name: 'violationPurchase' });
                        break;
                }
            })
                .catch(function () { });
            this.isHasBuy = false;
        },
        purchaseTimes: function () {
            var _this = this;
            var estimateCost = this.preCalculate.estimateCost;
            var usernameZh = this.usernameZh;
            var data = {
                type: 'BALANCE',
                amount: estimateCost,
                times: estimateCost * 0.1,
                operator: usernameZh,
            };
            this.$store.dispatch('common/GET_LOADING');
            this.$request({
                url: '/proxy/violation/purchase/do',
                method: 'post',
                data: data,
                loadingControl: 'hand',
            }).then(function (res) {
                if (res.errorCode === 0) {
                    _this.isHasBuy = true;
                    // const { source } = this.violationParams
                    _this.$store.dispatch('violationManage/GET_PRECALCULATE', {
                        // source,
                        data: __assign({}, _this.violationParams),
                        loadingControl: 'hand',
                        loading: _this.commonLoading,
                    });
                    return;
                }
                _this.commonLoading.close();
            });
        },
    },
    watch: {
        preCalculate: function () {
            this.$store.dispatch('balance/GET_BALANCE', {
                loadingControl: 'hand',
                loading: this.commonLoading,
            });
        },
        balanceData: function () {
            this.commonLoading.close();
            this.costNumber();
        },
    },
});
